import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule, ActivatedRoute, Router } from "@angular/router";

import { SidebarComponent } from './sidebar.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FontAwesomeModule
  ],
  declarations: [
    SidebarComponent
  ],
})
export class SidebarModule { }


// WEBPACK FOOTER //
// ./src/app/sidebar/sidebar.module.ts